import { ActivatedRoute, DefaultUrlSerializer, NavigationStart, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { AppConfigService } from "./services/app-config.service";
import { ContextService } from "./services/context.service";
import { TrackingService } from "./services/tracking.service";
import { TrackingFacadeService } from "./services/tracking/tracking-facade.service";

export function startup(
    ctxService: ContextService, 
    trackingFacadeService: TrackingFacadeService, 
    trackingService: TrackingService, 
    router: Router, 
    activatedRoute: ActivatedRoute,
    appConfigService : AppConfigService)
{

    // below code is for serviec window/maintanence page
    
    // activatedRoute.queryParams.subscribe(qParms => {
    //     router.events.pipe(
    //         filter((event) => event instanceof NavigationStart))
    //         .subscribe((event =>
    //         {
    //             const penetrate = sessionStorage.getItem('penetrate');
                
    //             if (penetrate !== 'true')
    //             {
    //                 const parsedUrl = (new DefaultUrlSerializer()).parse((<NavigationStart>event).url);

    //                 if(parsedUrl.queryParams['penetrate'] === 'true')
    //                 {
    //                     sessionStorage.setItem('penetrate', 'true');
    //                 } else 
    //                 {
    //                     (<any>window).location.href = '/maintenance.html';
    //                 }
    //             }
    //         }));
    // });
    
    // Return empty function.
    // By DI referencing ContextService, constructor is called.
    return () => {
        return appConfigService.loadAppConfig();
    };
}
